<div [dlNodeVolger]="node" [cy]="cy" ankertype="rechtsonder" [offset]="{x: 5, y: 5}" [volgFormaat]="false" [schaalMetZoom]="false" [zichtbaarAls]="modelcanvas.nodeOverlaysZichtbaar" class="dl-nodemenu__holder" (pointerover)="opItemHover($event)" (pointerleave)="opMenuVerlaten()">
    <ul class="dl-nodemenu">
        @if (!condtag || node.data('condstate') === condtag.state) {
            <li class="dl-nodemenu__item" data-uitleg="d_calc_plus" (click)="uitvoerChangeAction({type: 'd_calc_plus'})" title="{{ 'ADD_CALC_PLUS' | translate }}">
                <a class="q_calc_plus"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="d_calc_min" (click)="uitvoerChangeAction({type: 'd_calc_min'})" title="{{ 'ADD_CALC_MIN' | translate }}">
                <a class="q_calc_min"></a>
            </li>
            @if (effectiefModelleerniveau >= 50) {
                <li class="dl-nodemenu__item" data-uitleg="d_calc_mult" (click)="uitvoerChangeAction({type: 'd_calc_mult'})" title="{{ 'ADD_CALC_MULT' | translate }}">
                    <a class="q_calc_mult"></a>
                </li>
            }
            @if (effectiefModelleerniveau >= 50) {
                <li class="dl-nodemenu__item" data-uitleg="d_calc_div" (click)="uitvoerChangeAction({type: 'd_calc_div'})" title="{{ 'ADD_CALC_DIV' | translate }}">
                    <a class="q_calc_div"></a>
                </li>
            }
        }
        <li class="dl-nodemenu__separator"></li>
        <li class="dl-nodemenu__item" (click)="toggleSubmenu('dcalc_ineq_menu')" title="{{ 'CALC_INEQ_SUBMENU' | translate }}">
            <a class="equal"></a>
        </li>
        <li class="dl-nodemenu__item" (click)="toggleSubmenu('d_calc_menu')" title="{{ 'CALC_SUBMENU' | translate }}">
            <a class="q_calc_plusmin"></a>
        </li>
        @if (!condtag || node.data('condstate') === condtag.state) {
            <li class="dl-nodemenu__item" (click)="uitvoerSwitchArgs()" title="{{ 'SWITCH_ARGS' | translate }}">
                <a class="switch_args"></a>
            </li>
        }
        <li class="dl-nodemenu__separator dl-nodemenu__item"></li>
        <li class="dl-nodemenu__item" (click)="uitvoerEditBallon()" title="{{ 'BALLON.BTN_TITLE' | translate }}">
            <a class="fa_item"><span class="fa-regular fa-comment"></span></a>
        </li>
    </ul>
    @if (actievSubmenu() === 'dcalc_ineq_menu') {
        <ul class="dl-nodemenu__submenu">
            <li class="dl-nodemenu__item" data-uitleg="d_ineq_lt" [class.selectedMenuItem]="isActiefInitAddActie('d_ineq_lt')" (click)="uitvoerInitAddAction({type: 'd_ineq_lt'})" title="{{ 'ADD_INEQ_LT' | translate }}">
                <a class="q_ineq_lt"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="d_ineq_lte" [class.selectedMenuItem]="isActiefInitAddActie('d_ineq_lte')" (click)="uitvoerInitAddAction({type: 'd_ineq_lte'})" title="{{ 'ADD_INEQ_LTE' | translate }}">
                <a class="q_ineq_lte"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="d_ineq_eq" [class.selectedMenuItem]="isActiefInitAddActie('d_ineq_eq')" (click)="uitvoerInitAddAction({type: 'd_ineq_eq'})" title="{{ 'ADD_INEQ_EQ' | translate }}">
                <a class="q_ineq_eq"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="d_ineq_gte" [class.selectedMenuItem]="isActiefInitAddActie('d_ineq_gte')" (click)="uitvoerInitAddAction({type: 'd_ineq_gte'})" title="{{ 'ADD_INEQ_GTE' | translate }}">
                <a class="q_ineq_gte"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="d_ineq_gt" [class.selectedMenuItem]="isActiefInitAddActie('d_ineq_gt')" (click)="uitvoerInitAddAction({type: 'd_ineq_gt'})" title="{{ 'ADD_INEQ_GT' | translate }}">
                <a class="q_ineq_gt"></a>
            </li>
        </ul>
    }
    @if (actievSubmenu() === 'd_calc_menu') {
        <ul class="dl-nodemenu__submenu">
            <li class="dl-nodemenu__item" data-uitleg="d_calc_plus" [class.selectedMenuItem]="isActiefInitAddActie('d_calc_plus')" (click)="uitvoerInitAddAction({type: 'd_calc_plus'})" title="{{ 'ADD_CALC_PLUS' | translate }}">
                <a class="q_calc_plus"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="d_calc_min" [class.selectedMenuItem]="isActiefInitAddActie('d_calc_min')" (click)="uitvoerInitAddAction({type: 'd_calc_min'})" title="{{ 'ADD_CALC_MIN' | translate }}">
                <a class="q_calc_min"></a>
            </li>
            @if (effectiefModelleerniveau >= 50) {
                <li class="dl-nodemenu__item" data-uitleg="d_calc_mult" [class.selectedMenuItem]="isActiefInitAddActie('d_calc_mult')" (click)="uitvoerInitAddAction({type: 'd_calc_mult'})" title="{{ 'ADD_CALC_MULT' | translate }}">
                    <a class="q_calc_mult"></a>
                </li>
            }
            @if (effectiefModelleerniveau >= 50) {
                <li class="dl-nodemenu__item" data-uitleg="d_calc_div" [class.selectedMenuItem]="isActiefInitAddActie('d_calc_div')" (click)="uitvoerInitAddAction({type: 'd_calc_div'})" title="{{ 'ADD_CALC_DIV' | translate }}">
                    <a class="q_calc_div"></a>
                </li>
            }
        </ul>
    }
</div>
